module.exports = __webpack_public_path__ + "static/media/certs.703a414e.png";